import React, {Component} from 'react';
const { connect } = require('react-redux');

import '../../sass/member/MemberAmateurFilms.scss';

import Footer from '../../components/Footer';
import HeaderMemberAmateurFilms from '../../components/member/HeaderMemberAmateurFilms';
import AmateurFilmList from 'components/list/AmateurFilmList';

import {getMemberAmateurFilms} from 'reducers/memberAmateurFilms';

import {t} from 'l10n';

import {sortCallbackDate, sortCallbackPopularity} from 'utils/amateurFilms';
import queryString from "query-string";

class MemberAmateurFilms extends Component {
    constructor(props) {
        super(props);

        this.state = {
            order: 'date'
        }
    }

    componentDidMount() {
        this.props.getMemberAmateurFilms();
    }
    
    updateOrder(order) {
        let {history, location} = this.props;
        
        let params = { order };
        
        this.setState({order});
        
        history.push(
            location.pathname + '#' + queryString.stringify(params)
        );
    }

    render() {
        let {memberAmateurFilms} = this.props;

        let {order} = this.state;

        if (order === 'date') {
            memberAmateurFilms.sort(sortCallbackDate);
        } else if (order === 'popularity') {
            memberAmateurFilms.sort(sortCallbackPopularity);
        }

        return (
            <div id="wrapper">
                <HeaderMemberAmateurFilms onUploadFilmSuccess={() => this.props.getMemberAmateurFilms()}/>
                <aside className="myfilms">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('My amateur videos')} <em>{memberAmateurFilms.length}</em></h2>
                            <div className="sort">
                                <p>{t('Sort by:')}</p>
                                <div className="ui-selector ui-mini film-sort-selector">
                                    <div className={order === 'date' ? 'active' : ''} onClick={() => this.updateOrder("date")}>{t('date')}</div>
                                    <div className={order === 'views' ? 'active' : ''} onClick={() => this.updateOrder("views")}>{t('popularity')}</div>
                                </div>
                            </div>
                        </div>
                        <AmateurFilmList amateurFilms={memberAmateurFilms} showDate showStats/>
                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberAmateurFilms: state.memberAmateurFilms
    }),({
        getMemberAmateurFilms: getMemberAmateurFilms
    })
)(MemberAmateurFilms)


// WEBPACK FOOTER //
// ./src/containers/member/MemberAmateurFilms.js